import React, { useContext, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { AuthContext } from '../contexts/AuthContext';
import './Header.css';

/**
 * Application header component
 */
function Header() {
  const { isAuthenticated, user, logout, isPremium } = useContext(AuthContext);
  const [showUserMenu, setShowUserMenu] = useState(false);
  const navigate = useNavigate();
  
  // Toggle user dropdown menu
  const toggleUserMenu = () => {
    setShowUserMenu(prev => !prev);
  };
  
  // Close menu when clicking outside
  const closeUserMenu = () => {
    setShowUserMenu(false);
  };
  
  // Handle logout
  const handleLogout = () => {
    logout();
    closeUserMenu();
    navigate('/');
  };
  
  return (
    <header className="app-header">
      <div className="header-content">
        <div className="header-logo">
          <Link to="/" className="logo-link">
            <span className="logo-icon">AI</span>
            <span className="logo-text">Code Implementer</span>
          </Link>
        </div>
        
        <nav className="header-nav">
          <ul className="nav-list">
            <li className="nav-item">
              <Link to="/" className="nav-link">Home</Link>
            </li>
            {isAuthenticated && (
              <li className="nav-item">
                <Link to="/projects" className="nav-link">My Projects</Link>
              </li>
            )}
            <li className="nav-item">
              <Link to="/about" className="nav-link">About</Link>
            </li>
          </ul>
        </nav>
        
        <div className="header-actions">
          {isAuthenticated ? (
            <div className="user-menu-container">
              <button 
                className="user-menu-button"
                onClick={toggleUserMenu}
                aria-haspopup="true"
                aria-expanded={showUserMenu}
              >
                <span className="user-avatar">
                  {user?.name?.charAt(0) || '?'}
                </span>
                {isPremium && <span className="premium-badge">PRO</span>}
              </button>
              
              {showUserMenu && (
                <>
                  <div className="backdrop" onClick={closeUserMenu}></div>
                  <div className="user-dropdown">
                    <div className="user-info">
                      <div className="user-name">{user?.name}</div>
                      <div className="user-email">{user?.email}</div>
                    </div>
                    
                    <ul className="dropdown-menu">
                      <li className="dropdown-item">
                        <Link to="/profile" className="dropdown-link" onClick={closeUserMenu}>
                          Profile
                        </Link>
                      </li>
                      <li className="dropdown-item">
                        <Link to="/projects" className="dropdown-link" onClick={closeUserMenu}>
                          My Projects
                        </Link>
                      </li>
                      {!isPremium && (
                        <li className="dropdown-item">
                          <Link to="/premium" className="dropdown-link premium-link" onClick={closeUserMenu}>
                            Upgrade to Premium
                          </Link>
                        </li>
                      )}
                      <li className="dropdown-divider"></li>
                      <li className="dropdown-item">
                        <button className="dropdown-link logout-link" onClick={handleLogout}>
                          Log Out
                        </button>
                      </li>
                    </ul>
                  </div>
                </>
              )}
            </div>
          ) : (
            <div className="auth-buttons">
              <Link to="/login" className="login-button">Log In</Link>
              <Link to="/register" className="register-button">Sign Up</Link>
            </div>
          )}
        </div>
      </div>
    </header>
  );
}

export default Header;
